import { NativeModules } from 'react-native';

export type InstalledAppVersion = {
  versionName: string;
  buildNumber: string | null;
  bundleId: string | null;
};

type AppVersionConstants = {
  versionName?: unknown;
  buildNumber?: unknown;
  bundleId?: unknown;
};

type AppVersionModule = AppVersionConstants & {
  getConstants?: () => AppVersionConstants;
};

function text(value: unknown): string | null {
  return typeof value === 'string' && value.trim() ? value.trim() : null;
}

/**
 * Version actually installed on the device (Android versionName /
 * iOS CFBundleShortVersionString). Returns null when the native module is
 * unavailable (web, tests, or a binary built before the module existed).
 */
export function getInstalledAppVersion(): InstalledAppVersion | null {
  const native = NativeModules.AppVersion as AppVersionModule | undefined;
  if (!native) return null;
  const constants = native.getConstants?.() ?? native;
  const versionName = text(constants.versionName);
  if (!versionName) return null;
  return {
    versionName,
    buildNumber: text(constants.buildNumber),
    bundleId: text(constants.bundleId),
  };
}
